module.exports = __webpack_public_path__ + "demo-appsure-logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/demo-appsure-logo.jpg
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/demo-appsure-logo.jpg
// module chunks = 10